import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@web/walter-lib/auth'
import { Routes } from '~constants/routes'

export function SkipAuth() {
    const { isAuth } = useAuth()

    return isAuth ? <Navigate to={Routes.wallet} replace /> : <Outlet />
}
